module.exports = __webpack_public_path__ + "static/media/11.27c4a220.png";